// Central place for Streams of Joy brand assets. Update here for future rebrands.
export const LOGO_WHITE =
  "https://customer-assets.emergentagent.com/job_joy-erith-portal/artifacts/1lu6bdjq_SOJ-Monochome-White-Expression-Logos_SOJ-International%20%281%29.webp";

// Square app-icon logo (teal badge, white dove mark) — works on light & dark
export const LOGO_ICON =
  "https://customer-assets-rejwkqb3.emergentagent.net/job_joy-erith-portal/artifacts/gtobnktb_image-1784326629250.png";

// Full colour/dark SOJ London logo (transparent PNG) — use on LIGHT backgrounds
export const LOGO_DARK =
  "https://images.squarespace-cdn.com/content/v1/65098cb796e11607f4344a96/49bca038-23d0-49be-8c13-fdf25a156d4d/SOJ+WEBSITE+-+(I%27M+NEW)+-+WHY+JESUS+(11)26f7.png?format=1500w";
